import { Card, Form, Row, Col, Button, notification } from "antd";
import React from "react";
import { connect } from "react-redux";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper";
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import Request,{ API_URL, LAPI_URL } from "../../../request";
import async from 'async';
import _ from 'lodash'


@Form.create()
class WhatsappCampaign extends React.Component {
    state = {
        whatsappType:'',
        toWhatsapp:'',
        templateArr:[],
        whatsAppTemplates:[]
    }


    setTemplateData = (templateId) => {
        let {form:{setFieldsValue}} = this.props;
        let {whatsAppTemplates} = this.state;
        let foundTemplate = whatsAppTemplates.find(obj=>obj._id === templateId )
        if(foundTemplate) {
            setFieldsValue({templateBody:foundTemplate.templateData})
        }
    }

    loadWhatsappTemplates = async() =>{
        let response = await Request.getTemplatesForCommunication('Whatsapp');
        let templateArr = [];
        async.each(response,(template)=>{
            templateArr.push({id:template._id, display:template.templateName})
        })
        this.setState({templateArr, whatsAppTemplates:response})
    }

    handleSubmit = (e) =>{
        e.preventDefault();
        let {form} = this.props
        form.validateFieldsAndScroll(async(err,valData)=>{
            let values = _.clone(valData);
            let response = await Request.addWhatsappCampaign(values);
            if(response.success) {
                notification.success({
                    message:response.message
                })
            }else {
                notification.error({
                    message:response.message
                })
            }
            this.setState({toWhatsapp:'', whatsappType:''}, ()=>{
                form.resetFields();
            })
        })
    }

    componentDidMount() {
        this.loadWhatsappTemplates();
    }

    render() {
        const {form:{getFieldDecorator, setFieldsValue}} = this.props;
        let {whatsappType, toWhatsapp} = this.state;
        const inputTypes = {
            fields:[
                {
                    label:'Campaign Name',
                    key:'campaignName',
                    required:true
                },
                {
                    label:'Whatsapp Type',
                    key:'whatsappType',
                    type:'select',
                    required:true,
                    options:['Branch', 'University'],
                    onChange:v=>{
                        this.setState({whatsappType:v}, () =>{
                            setFieldsValue({whatsappType:v})
                        })
                        
                    }
                },
                {
                    label:'To Whatsapp',
                    key:'toWhatsapp',
                    type:'select',
                    required:true,
                    hidden:this.state.whatsappType === ""?true:false,
                    options:[{id:`active`, display:`Bulk Whatsapp To Active ${whatsappType}`},
                        {id:`custom`, display:`Custom - Whatsapp to Any Recipient`},
                        {id:`all`, display:`Bulk Whatsapp to All ${whatsappType}`},
                        {id:`excel`, display:`Excel Data - Bulk Whatsapp to New ${whatsappType}`}
                    ],
                    onChange:v=>{
                        this.setState({toWhatsapp:v}, () =>{
                            setFieldsValue({toWhatsapp:v});
                        })
                        
                    }
                },
                {
                    label:'Recipient Whatsapp with Country Code (Separated By ",")',
                    key:'whatsappNumbers',
                    required:toWhatsapp === "custom"?true:false,
                    hidden:toWhatsapp !== "custom"?true:false
                },
                {
                    label:'Upload Excel',
                    key:'whatsappFile',
                    type:'file',
                    required:toWhatsapp === "excel"?true:false,
                    hidden:toWhatsapp !== "excel"?true:false,
                    prefixComp:<small>Download Sample File <a href={`${API_URL}/media/whatsapp-campaign-sample.csv`}>Here</a></small>
                },
                {
                    label:'Choose Template',
                    key:'templateId',
                    type:'select',
                    required:true,
                    options:this.state.templateArr,
                    onChange:v=>{
                        setFieldsValue({templateId:v},()=>{
                            this.setTemplateData(v)
                        })
                    }
                },
                {
                    label:'Template Body',
                    key:'templateBody',
                    type:'textarea',
                    disabled:true,
                    rows:10
                }
            ]
        }
        return (
            <PageHeaderWrapper title="Whatsapp Campaign">
                <Card>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields getFieldDecorator={getFieldDecorator} inputSchema={inputTypes} apiurl={LAPI_URL} />
                        <Row style={{marginTop:'20px'}}>
                            <Col span={8}/>
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{marginBottom: 10}}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8}/>
                        </Row>
                    </Form>
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    categories: global.categories,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WhatsappCampaign)
